import { getRevenuePredictionEndpoint, } from 'root/src/server/modules/salesPrediction/endpoints/getRevenuePrediction.endpoint';
export const salesPredictionEndpoints = Object.assign({}, getRevenuePredictionEndpoint);
